export default __webpack_public_path__ + "static/media/megaphone.8071772a.png";